import close from "../../assets/images/New folder/close.png";
import { useTranslation } from "react-i18next";
import chargRules from "../../assets/images/New folder/charg rules 1.png";
const Dialog = ({ isOpen, closeDialog, description }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-[#1A0A04]   bg-opacity-80 flex items-center justify-center z-[999999]">
      <div
        style={{ width: "calc(100% - 20px)" }}
        className="w-[90%]  rounded-xl    relative dialog  shadow-lg"
      >
        <img
          src={chargRules}
          alt="dialog"
          className="inset-0 w-full h-[65%] object-cover rounded-2xl"
        />
        <div className="absolute top-[20%] h-[65%] inset-0 flex justify-center items-center">
          <p
            className="font-lemon w-[90%] scrollbar-hidden  overflow-y-auto text-[#FFFFFF99] md:text-xl sm:text-xl font-normal md:leading-[38.32px] xs:leading-[28.32px] text-center px-4 py-2"
            style={{
              maxHeight: "60%", // Limit the height to prevent overflow
              overflowY: "auto", // Add scroll if the content is too long
              whiteSpace: "normal", // Ensure text wraps
            }}
          >
            {description}
          </p>
        </div>
        <p className="absolute top-[-7px]    font-lemon left-1/2 w-full p-4 z-40 transform -translate-x-1/2 text-[#3F0A00]  xs:text-xl font-normal text-center">
          {t("Rules")}
        </p>
        <button
          onClick={closeDialog}
          className="absolute top-[20rem] z-50 right-[47%]"
        >
          <img src={close} alt="close" className="w-8" />
        </button>
      </div>
    </div>
  );
};

export default Dialog;
